import { User } from "@harlowe/core"

export namespace UserInterface
{

    export class LoggedIn
    {
        static readonly type ="[UI Login Action] Successful Login"
        constructor(public payload: { user: User }) {}
    }

    export class LoadRouteInSidebar
    {
        static readonly type = "[Router] Load Route in Sidebar";
        constructor(public payload: {route:string}){}
    }

    export class OpenSidebar
    {
        static readonly type="[App Component] Open Sidebar"
    }

    export class CloseSidebar
    {
        static readonly type="[Sidebar] Close Sidebar";
    }

    export class OpenEncounter
    {
        static readonly type="[EncounterManager] OpenEncounter";
    }

    export class OpenClaimTray
    {
        static readonly type="[Claim Tray] Open";
    }

    export class CloseClaimTray
    {
        static readonly type="[Claim Tray] Close";
    }

    export class ToggleClaimTray
    {
        static readonly type="[Claim Tray] Toggle";
    }
}